import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "./../assets/banner/portada.jpg";
import imgVertical from "./../assets/banner/imgvertical.jpg";
import logvefase from "./../assets/banner/logo-negro.webp";
import { FaAccessibleIcon } from 'react-icons/fa';
import Banner from "../components/Banner";
import AccessibilityModal from './../components/AccessibilityModal';
import { Link } from "react-router-dom";

const Servicios = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
     <div className="micolor-jm">
      <Header />
      <button className="floating-button" onClick={toggleModal}>
      <img
               src={require("../assets/clientes/iconoaccesibilidad.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "50px",
                height:"50px",
              
              }}
            />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />
    
  
      
      
      <div className="container">
        <div className="row row-jm">
          

      {/*     /////////////////servicios//////////////////////////////// */}

          <div className="col-md-6 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">NUESTROS SERVICIOS
            </h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5">
            
            
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
               src={require("../assets/home/ser1.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Diagnostico y <br></br>Estudio de Accesibilidad
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           Desarrollamos diagnóstico de la situación actual de la accesibilidad de tu empresa o entidad para brindarte las soluciones y planes de acción a ejecutar a un corto, mediano y largo plazo
           </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
               src={require("../assets/home/ser2.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Implementación<br></br> – Diseño, obra y supervisión
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           De acuerdo al análisis realizado diseñamos y ejecutamos las soluciones de accesibilidad que se requiere en el espacio (planos, mobiliario)
           </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/ser3.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Señalización Accesible
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           Brindamos diferentes tipos de señalización accesible que permita que las personas con discapacidad puedan desplazarse y orientarse de manera autónoma y segura.
           </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
               src={require("../assets/home/ser4.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Comunicación Accesible
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           Desarrollamos diferentes tipos de comunicación (impresión, videos) con componentes de accesibilidad para museos, centros educativos, restaurantes, hoteles, entre otros espacios.
           </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
               src={require("../assets/home/ser5.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Capacitaciones y Talleres
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           Realizamos talleres, capacitaciones y charlas enfocados a la accesibilidad, inclusión y diversidad, de manera presencial o virtual.
           </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/ser6.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "40%",
              }}
            />
           <p className="mitexto text-left mt-3">
           <strong style={{ color: "#000" }}>Asesoría en Inserción Laboral
           </strong>
           <br></br>
           <p style={{ marginRight: 45, fontSize: 16, color: '#000' }}>
           Asesoramos y acompañamos a las empresas para que de manera progresiva implementen ajustes razonables y estrategias para la inserción laboral de personas con discapacidad
           </p>
            </p>
          </div>


          <div className="col-md-12 col-sm-12 mt-5">
              <div className="text-center"> 
               
                   <Link to="/contacto">
                        <button className="contact-button">Contáctanos para más información</button>
                    </Link>
              </div>
          </div>
          <div className="col-md-12 col-sm-12 mt-5 mb-5"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Servicios;